import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import Results from "@/pages/Results";
import Couple from "@/pages/Couple";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminShortcut from "@/components/AdminShortcut";
import { DevBanner, FeedbackFab } from "@/components/Feedback";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <DevBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/quiz"
              element={<ProtectedRoute><Quiz /></ProtectedRoute>}
            />
            <Route
              path="/results/:id"
              element={<ProtectedRoute><Results /></ProtectedRoute>}
            />
            <Route path="/couple/:id" element={<Couple />} />
            <Route
              path="/couple/:id/take"
              element={<ProtectedRoute><Quiz /></ProtectedRoute>}
            />
            <Route
              path="/admin"
              element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>}
            />
          </Routes>
          <FeedbackFab />
          <AdminShortcut />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
